export default {
    setArticles(state, data) {
        state.articles = data
    },
    setArticle(state, data) {
        state.article = data
    },
    setArticlesConfig(state, data) {
        state.articlesConfig = data
    },
    setCategories(state, data) {
        state.categories = data
    },
    setCategoriesConfig(state, data) {
        state.categoriesConfig = data
    }
}
